import { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';

import * as Meta from 'meta';
import { setDailyAdult, gaEvent } from 'utils';
import { Footer } from 'components';

export const IntroPage: FC = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const redirect = query.get('location') || '/';

  return (
    <div className="wrapper">
      {Meta.loadCSS("intro")}
      {Meta.loadJS(["main-0625", "intro-0625"])}
      {Meta.ga("18歲法規頁")}
      <div className="logo"><img src="/resources/html/images/intro/logo_w.svg" alt="台灣啤酒" /></div>
      <div className="main">
        <div className="intro_text">
          <div className="intro_talk">
            <p>享受暢快爽勁！爽事即將來臨！</p>
          </div>
          <div className="intro_in">滿18歲了嗎？</div>
          <div className="intro_bt">
            <Link to={redirect} onClick={() => {
              setDailyAdult();
              gaEvent('18歲法規頁', 'yes');
            }}><li>YES</li></Link>
            <li className="intro_no" onClick={gaEvent.bind(null, '18歲法規頁', 'no')}>NO</li>
          </div>
        </div>
        <div className="intro_text_milk">
          <div className="intro_talk"> 屬於你的暢快爽勁<br />有⼀天會來臨</div>
          <div className="intro_in"><span>喝杯牛奶 快快長⼤</span><br />我們等你!</div>
        </div>
        <div className="songbeer"><img src="/resources/html/images/intro/songbeer.png" /></div>
        <div className="milk"><img src="/resources/html/images/intro/milk.png" /></div>
        <img className="intro_left" src="/resources/html/images/intro/intro_left.png" />
        <img className="intro_right" src="/resources/html/images/intro/intro_right.png" />
      </div>
      <Footer />
    </div>
  );
};
